import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["anchor"];

  static values = {
    behavior: { type: String, default: "smooth" },
    block: { type: String, default: "start" },
    inline: { type: String, default: "nearest" },
  };

  scroll(event) {
    const el = document.querySelector(event.params.anchor) || this.anchorTarget;

    el.scrollIntoView({
      behavior: this.options.behavior,
      block: this.options.block,
      inline: this.options.inline,
    });
  }

  get options() {
    return {
      behavior: this.behaviorValue,
      block: this.blockValue,
      inline: this.inlineValue,
    };
  }
}
